import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Projects from "@/components/Projects";
import CompetitiveEdge from "@/components/CompetitiveEdge";
import Process from "@/components/Process";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { useState } from "react";

const Index = () => {
  const [contactDialogOpen, setContactDialogOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <Navigation onContactClick={() => setContactDialogOpen(true)} />
      <Hero />
      <Services />
      <Projects />
      <Process />
      <CompetitiveEdge />
      <Contact dialogOpen={contactDialogOpen} setDialogOpen={setContactDialogOpen} />
      <Footer />
    </div>
  );
};

export default Index;